module.exports = __webpack_public_path__ + "img/head-big-eye.9f2f3f06.png";